import socketIOClient from 'socket.io-client'
import cloneDeep from 'lodash.clonedeep'

var ClientSocket = function (endpoint, token, clientUID) {
  this.token = token
  this.ioclient = null
  this.authorized = false
  this.connected = false
  this.frameInfo = null
  this.disabled = false
  this.callbacks = {
    onConnectionChange: {},
    onLocationOpenStateUpdated: {},
    onLocationClosedUntilChange: {},
    onDeviceStateUpdated: {},
    onItemVisibilityChanged: {},
    onOrderUpdated: {},
    onDeviceForceLogout: {},
    onDeviceDisableDuplicate: {},
    onCatalogUpdated: {},
    onAppParamsUpdated: {},
    deviceParamsUpdated: {},
    onLocationExtendedPrepTimeUpdated: {},
    onPrintOrderSlip: {},
    onPrintersUpdated: {},
    onLocationsUpdated: {},
    onLocationCloudDeviceUpdated: {},
    secondScreenMessage: {},
    mainScreenMessage: {},
    onDocumentUpdated: {}
  }

  this.init = async (frameInfo = null) => {
    this.frameInfo = frameInfo
    this.addCallback('onConnectionChange', 'ClientSocket.self', this.onConnectionChange)
    this.createConnection()
  }

  this.onConnectionChange = (data) => {
    switch (data.state) {
      case 'Disconnected': setTimeout(this.tryReconnect, 5000)
        break
    }
  }

  this.setToken = (token) => {
    if (this.token !== token) {
      this.token = token
      this.reConnect()
    }
  }

  this.createConnection = () => {
    if (this.ioclient != null) {
      this.reConnect()
      return
    }
    let urlParts = endpoint.replace('://', '/').split(/[/?#]/)
    let socketUrl = `${urlParts[0]}://${urlParts[1]}`
    this.ioclient = socketIOClient(socketUrl, { transports: ['websocket', 'polling'] })
    this.ioclient.on('connect', () => {
      this.connected = true
      this.ioclient.emit('authentication', {
        token: this.token
      })
      this.callCallbacks('onConnectionChange', { state: 'Connected', message: '' })
    })
    this.ioclient.on('unauthorized', (reason) => {
      this.authorized = false
      this.callCallbacks('onConnectionChange', { state: 'Unauthorized', message: reason.message })
    })
    this.ioclient.on('authorized', (data) => {
      this.authorized = true
      this.callCallbacks('onConnectionChange', { state: 'Authorized', message: '', data })
      this.ioclient.on('inited', () => {
        this.callCallbacks('onConnectionChange', { state: 'Ready', message: '', data })
      })
      this.ioclient.emit('init', { deviceInfo: { ...this.frameInfo, clientUID } })
    })
    this.ioclient.on('disconnect', () => {
      this.connected = false
      this.authorized = false
      this.callCallbacks('onConnectionChange', { state: 'Unauthorized', message: 'Disconnected' })
      this.callCallbacks('onConnectionChange', { state: 'Disconnected', message: '' })
    })
    this.ioclient.on('locationClosedUntilChange', (data) => {
      this.callCallbacks('onLocationClosedUntilChange', { locationUUID: data.locationUUID, openHoursType: data.openHoursType, until: data.until })
    })
    this.ioclient.on('locationOpenStateUpdated', (data) => {
      this.callCallbacks('onLocationOpenStateUpdated', { ...data })
    })
    this.ioclient.on('locationExtendedPrepTimeUpdated', (data) => {
      this.callCallbacks('onLocationExtendedPrepTimeUpdated', { ...data })
    })
    this.ioclient.on('onItemVisibilityChanged', (data) => {
      this.callCallbacks('onItemVisibilityChanged', { data })
    })
    this.ioclient.on('orderUpdated', (data) => {
      this.callCallbacks('onOrderUpdated', data)
    })
    this.ioclient.on('documentUpdated', (data) => {
      this.callCallbacks('onDocumentUpdated', data)
    })
    this.ioclient.on('deviceStateUpdated', (data) => {
      this.callCallbacks('onDeviceStateUpdated', { ...data })
    })
    this.ioclient.on('deviceForceLogout', () => {
      this.callCallbacks('onDeviceForceLogout', {})
    })
    this.ioclient.on('deviceDisableDuplicate', (data) => {
      this.callCallbacks('onDeviceDisableDuplicate', { ...data })
    })
    this.ioclient.on('catalogUpdated', () => {
      this.callCallbacks('onCatalogUpdated', {})
    })
    this.ioclient.on('appParamsUpdated', (data) => {
      this.callCallbacks('onAppParamsUpdated', data)
    })
    this.ioclient.on('deviceParamsUpdated', (data) => {
      this.callCallbacks('deviceParamsUpdated', data)
    })
    this.ioclient.on('printOrderSlip', (data) => {
      this.callCallbacks('onPrintOrderSlip', data)
    })
    this.ioclient.on('printersUpdated', (data) => {
      this.callCallbacks('onPrintersUpdated', data)
    })
    this.ioclient.on('locationsUpdated', (data) => {
      this.callCallbacks('onLocationsUpdated', data)
    })
    this.ioclient.on('locationCloudDeviceUpdated', (data) => {
      this.callCallbacks('onLocationCloudDeviceUpdated', data)
    })
    this.ioclient.on('secondScreenMessage', (data) => {
      this.callCallbacks('secondScreenMessage', data)
    })
    this.ioclient.on('mainScreenMessage', (data) => {
      this.callCallbacks('mainScreenMessage', data)
    })
    setTimeout(this.tryReconnect, 10000)
  }

  this.reConnect = () => {
    if (this.disabled) {
      return
    }
    if (this.ioclient != null) {
      this.ioclient.disconnect()
      this.ioclient.connect()
    } else {
      this.createConnection()
    }
  }

  this.disable = () => {
    this.disabled = true
    if (this.ioclient != null) {
      this.ioclient.disconnect()
    }
  }

  this.tryReconnect = () => {
    if (this.disabled) {
      return
    }
    if (!this.connected) { 
      if (this.token != null && this.token !== '') {
        this.reConnect()
      }
    }
    setTimeout(this.tryReconnect, 10000)
  }

  this.addCallback = (cbName, name, func) => {
    try {
      this.callbacks[cbName][name] = func
    } catch (e) {
      console.error('Invalid callback name', cbName)
    }
  }

  this.removeCallback = (cbName, name) => {
    try {
      delete this.callbacks[cbName][name]
    } catch (e) {
      console.error('Invalid callback name', cbName)
    }
  }

  this.callCallbacks = async (cbName, message, reason = null) => {
    //if (reason) console.log(reason, cloneDeep(message))
    for (let callback of Object.values(this.callbacks[cbName] || {})) {
      if (typeof callback === 'function') {
        try {
          callback(cloneDeep(message))
        } catch (e) {
          console.error(e)
        }
      }
    }
  }
}

export { ClientSocket }
